import { Tactic } from "@/redux/tactics/tacticsSlice";

import {
  Manager,
  Metal,
  Scope,
  SquadBuilderPlayerType,
} from "../../../redux/squadBuilder/squadBuilderUtils";
import axios from "../../api";

interface FromBackendSquad {
  players: SquadBuilderPlayerType[];
  manager: Manager;
  chemistry: number;
  metaRating: number;
}

export interface BestFormationFromBackendSquad extends FromBackendSquad {
  tactic: Tactic;
}

interface BaseBuildSquads {
  playersFrom: Scope;
  budget: number;
  benchBudget: number;
  manager: Manager;
  country: number[];
  league: number[];
  club: number[];
  pastAndPresentClub: number[];
  version: number[];
  metal: Metal[];
  excludeIconsHeroes: boolean;
  minRating: number;
  maxRating: number;
  includeLoanPlayers: boolean;
  liveEventId?: number;
}

interface BuildSquads extends BaseBuildSquads {
  players: { resourceId?: number; playerRoleId: number; position: string }[];
  playerFilters: undefined[] | any[];
  formationId: string;
}

interface BuildSquadsWithBestFormation extends BaseBuildSquads {
  players: { resourceId: number; eaPlayerId?: number }[];
}

export const buildSquads = ({
  playersFrom,
  players,
  budget,
  benchBudget,
  manager,
  country,
  league,
  club,
  pastAndPresentClub,
  version,
  metal,
  playerFilters,
  formationId,
  excludeIconsHeroes,
  minRating,
  maxRating,
  includeLoanPlayers,
  liveEventId,
}: BuildSquads) => {
  return axios.post<FromBackendSquad[]>("/squad-builder?v=2", {
    playersFrom,
    players,
    formationId,
    budget,
    benchBudget,
    manager,
    metal,
    country,
    league,
    club,
    pastAndPresentClub,
    version,
    playerFilters,
    excludeIconsHeroes,
    minRating,
    maxRating,
    includeLoanPlayers,
    liveEventId,
  });
};

export const buildSquadsWithBestFormation = ({
  playersFrom,
  players,
  budget,
  benchBudget,
  manager,
  country,
  league,
  club,
  pastAndPresentClub,
  version,
  metal,
  excludeIconsHeroes,
  minRating,
  maxRating,
  includeLoanPlayers,
  liveEventId,
}: BuildSquadsWithBestFormation) => {
  return axios.post<BestFormationFromBackendSquad[]>(
    "/squad-builder/any-formation",
    {
      playersFrom,
      players,
      budget,
      benchBudget,
      manager,
      country,
      league,
      club,
      pastAndPresentClub,
      version,
      metal,
      excludeIconsHeroes,
      minRating,
      maxRating,
      includeLoanPlayers,
      liveEventId,
    },
  );
};

/**
 * My Club's best possible squad: every formation, players from the user's own
 * club only. The backend builds the request itself; the first one is free
 * (it ticks MY_CLUB_ONBOARDING_SHOW_BEST), later ones cost a credit.
 */
export const buildBestClubSquad = () =>
  axios.post<BestFormationFromBackendSquad[]>(
    "/squad-builder/my-club-best-squad",
  );
